import * as React from 'react'

import { Organization } from '../../../models'

export interface Props {
  organization: Organization
  orgSelected: Organization
}

const Column = ({ children }) => <div style={{ display: 'flex', flexDirection: 'column' }}>{children}</div>

const Row = ({ href, selected, children }: any) => (
  <a
    className="nav__actions__apps__row"
    data-cy="orgsRow"
    href={href}
    style={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      fontWeight: 600,
      paddingTop: '0px',
      marginBottom: '6px',
      paddingLeft: '16px',
      paddingRight: '25px',
      lineHeight: '22px',
      borderLeftWidth: '5px',
      borderLeftColor: selected ? 'var(--blue-6)' : '#FFFFFF',
      borderLeftStyle: 'solid',
    }}
  >
    {children}
  </a>
)

const OrgListSwitcher = ({ organization, orgSelected }: Props) => (
  <Row
    href={`/org/manager/${organization.id}`}
    selected={orgSelected && orgSelected.id === organization.id}
  >
    <Column data-cy={`orgList_${organization.id}`}>
      {organization.name}
    </Column>
  </Row>
)

export default OrgListSwitcher
